import { PileOfRubbishIcon, WheelieBinIcon } from './CategoryIcons';
import './OtherServices.css';

const ITEMS = [
  { label: 'Pile of Scrap', href: '#pile-of-scrap', Icon: PileOfRubbishIcon },
  { label: 'Scrap Bin Empty', href: '#scrap-bin-empty', Icon: WheelieBinIcon },
];

export default function OtherServices() {
  return (
    <section className="other-services" aria-labelledby="other-services-heading">
      <div className="other-services-inner">
        <h2 id="other-services-heading">Other Scrap Services</h2>

        <ul className="other-services-grid">
          {ITEMS.map(({ label, href, Icon }) => (
            <li key={label}>
              <a className="other-services-link" href={href}>
                <span className="other-services-art">
                  <Icon />
                </span>
                <span className="other-services-label">
                  {label} <span aria-hidden="true">→</span>
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
